<div class="formgrid grid overflow-visible">
  <div class="box">
    <p>Are you sure you want to delete the user '{{ userName }}'?</p>
    <p>They will no longer have access to their DemandScience account.</p>
  </div>
</div>
<div class="flex justify-content-end gap-2">
  <p-button (onClick)="cancel()" [outlined]="true" label="Cancel" />
  <p-button (onClick)="delete()" label="Delete User" />
</div>
